import { TextInput, type TextInputSize } from './text-input.tsx'

type SearchInputProps = {
  value?: string
  onChange?: (value: string) => unknown
  /** A search field has no visible label, so this is its whole accessible name. */
  ariaLabel: string
  size?: TextInputSize
  debounce?: number
}

/** The app's one search field: owns the placeholder and the debounce so every search box moves together. */
export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  ariaLabel,
  size = 'small',
  debounce = 200,
}) => {
  return (
    <TextInput
      type="search"
      size={size}
      placeholder="Search"
      ariaLabel={ariaLabel}
      value={value}
      onChange={onChange}
      debounce={debounce}
    />
  )
}
